import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import Translation from '../../Translation/cont/Translation'
import { EDIT_PRINT_CAP } from '../../../constants/caps'
import ImageDisplayAndUpload from '../../forms/fields/ImageDisplayAndUpload'
import FieldWrapper from '../../forms/FieldWrapper'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import ButtonSubmitCancel from '../../general/ButtonSubmitCancel'
import { sanitizeFormInput, sanitizeFormOutput } from '../../../functions/formFunctions'
import WrapperAccordion from '../../general/WrapperAccordion';
import { withRouter } from 'react-router-dom';
import { TextEditor } from '../../forms/fields/TextEditor';

const EditFlyer = ({itemData, onUpdateItem, history, closePagePath}) => {
    const pageName = itemData && (itemData.flyerSettings.name || itemData.pk)
    ? [itemData.flyerSettings.name, <Translation key="edit" id="print_flyer_edit" before=" "/>] 
    : [<Translation key="new" id="print_flyer_new_flyer"/>] 
    const [editTopTitle, setEditTopTitle] = useState(itemData.flyerSettings.titleTopText ? true : false)
    const [editBottomTitle, setEditBottomTitle] = useState(itemData.flyerSettings.titleBottomText ? true : false)

    return (
        <WrapperPageSimple pageTitle={pageName} closePagePath={closePagePath}>
            <div className="program-page flyer site-content">
                {itemData ? (
                    <Formik
                        initialValues={sanitizeFormInput(itemData)}
                        onSubmit={(values, actions) => {
                            if(!values.pk) {
                                values.pk = uuidv4()
                            }

                            onUpdateItem(sanitizeFormOutput(values))
                            history.push(closePagePath)
                        }}
                        
                        onReset={(values, actions) => {
                            history.push(closePagePath)
                        }}
                    >
                    {({ values, errors, status, touched, isSubmitting, handleReset, setFieldValue }) => (
                            <Form>
                                <WrapperAccordion
                                    className="single-section"
                                    selectionActiveClass="accordion-item-open"
                                >
                                    <fieldset>
                                        <div className="form-content flyer">
                                            <div className="left-sections">
                                                 <FieldWrapper label={"Name"} id="flyer-name" classes="field-text">
                                                    <Field type="text" name="flyerSettings.name" id="flyer-name" className="text-regular input-text-box" />
                                                    <ErrorMessage className="text-regular-color" name="flyerSettings.name" component="div" /> 
                                                </FieldWrapper>
                                                <FieldWrapper classes="image field-text" label={<Translation id="logo"/>} id="flyer-logo" >
                                                    <Field 
                                                        name="flyerSettings.logo"
                                                        component={ImageDisplayAndUpload}
                                                    />
                                                </FieldWrapper>
                                                 <FieldWrapper label={<Translation id="style_newsletterBackground"/>} id="flyer-background" classes="field-text">
                                                    <Field type="text" name="flyerSettings.flyerBackground" id="flyer-background" className="text-regular input-text-box" />
                                                    <ErrorMessage className="text-regular-color" name="flyerSettings.flyerBackground" component="div" /> 
                                                </FieldWrapper>
                                                 <FieldWrapper label={<Translation id="print_flyer_text_color"/>} id="flyer-text-color" classes="field-text">
                                                    <Field type="text" name="flyerSettings.flyerTextColor" id="flyer-text-color" className="text-regular input-text-box" />
                                                    <ErrorMessage className="text-regular-color" name="flyerSettings.flyerTextColor" component="div" /> 
                                                </FieldWrapper>
                                                <div className='field-text'>
                                                    <label>
                                                        <p className='gap-10'><Translation id="print_flyer_top_text"></Translation></p>
                                                    
                                                        <Field type="checkbox" checked={editTopTitle} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                                            const currentTextState = editTopTitle ? '' : '<p></p>'
                                                            setFieldValue("flyerSettings.titleTopText", currentTextState)
                                                            setEditTopTitle(!editTopTitle)
                                                        }}/>
                                                        <span className="tgl-btn text-regular"><span className='screen-reader-text'><Translation id="print_flyer_activate_customization">Aktiv</Translation></span></span>
                                                    </label>
                                                </div>
                                                {editTopTitle && <FieldWrapper id="flyer-top-text" classes="field-textarea field-textarea-text">
                                                    <TextEditor
                                                        setFieldValue={(val) => {
                                                            const value = editTopTitle ? val : ''
                                                            setFieldValue("flyerSettings.titleTopText", value)
                                                        }}
                                                        value={values.flyerSettings.titleTopText}
                                                    />
                                                    <ErrorMessage className="text-regular-color" name="flyerSettings.titleTopText" component="div" /> 
                                                </FieldWrapper>}
                                                <div className='field-text'>
                                                    <label>
                                                        <p className='gap-10'><Translation id="print_flyer_bottom_text"></Translation></p>
                                                    
                                                        <Field type="checkbox" checked={editBottomTitle} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                                            const currentTextState = editBottomTitle ? '' : '<p></p>'
                                                            setFieldValue("flyerSettings.titleBottomText", currentTextState)
                                                            setEditBottomTitle(!editBottomTitle)
                                                        }}/>
                                                        <span className="tgl-btn text-regular"><span className='screen-reader-text'><Translation id="print_flyer_activate_customization">Aktiv</Translation></span></span>
                                                    </label>
                                                </div>
                                                {editBottomTitle && <FieldWrapper id="flyer-bottom-text" classes="field-textarea field-textarea-text">
                                                    <TextEditor
                                                        setFieldValue={(val) => {
                                                            const value = editBottomTitle ? val : ''
                                                            setFieldValue("flyerSettings.titleBottomText", value)}
                                                        }
                                                        value={values.flyerSettings.titleBottomText}
                                                    />
                                                    <ErrorMessage className="text-regular-color" name="flyerSettings.titleBottomText" component="div" /> 
                                                </FieldWrapper>}
                                            </div>
                                        </div>
                    
                                        <ButtonSubmitCancel
                                            transIdCancel="cancel_button"
                                            transIdSubmit="save_item_button"
                                            cap={EDIT_PRINT_CAP}
                                            disabledCancel={isSubmitting}
                                            disabledSubmit={isSubmitting}
                                            onCancel={handleReset}
                                        />
                                    </fieldset>
                                </WrapperAccordion>
                            </Form>
                        )}

                    </Formik>
                ) : (
                    <div><Translation id="no_data"/></div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default withRouter(EditFlyer)